// Shared by the browser and the build gate. Firebase web configuration is public.
const production = {
  apiKey: 'AIzaSyCS3fLxsle7_jw2rMwgmnOE2e08myuUPOM',
  authDomain: 'keval-io.firebaseapp.com', projectId: 'keval-io',
  storageBucket: 'keval-io.appspot.com', messagingSenderId: '254536923506',
  appId: '1:254536923506:web:24ba93705aaee80051c5eb', measurementId: 'G-DPW9SD5M37',
};

function resolveEnvironment(env) {
  const target = env.REACT_APP_FIREBASE_TARGET;
  if (!['emulator', 'preview', 'development', 'production'].includes(target)) {
    throw new Error('Set REACT_APP_FIREBASE_TARGET to emulator, preview, development or production.');
  }
  const emulators = Object.fromEntries(['auth', 'firestore', 'storage'].map((service) => [
    service, env[`REACT_APP_${service.toUpperCase()}_EMULATOR_HOST`] || null,
  ]));
  if (target === 'preview') {
    if (Object.values(emulators).some(Boolean)
      || (env.REACT_APP_FIREBASE_PROJECT_ID && env.REACT_APP_FIREBASE_PROJECT_ID !== 'demo-keval-preview')
      || env.REACT_APP_BLOG_WRITES_ENABLED === 'true' || env.REACT_APP_BLOG_UPLOADS_ENABLED === 'true') {
      throw new Error('Sample previews cannot connect to services or enable writes.');
    }
    return { target, firebaseConfig: { apiKey: 'demo-api-key', projectId: 'demo-keval-preview', appId: 'demo-keval-preview' },
      ownerUid: '', emulators, writesEnabled: false, uploadsEnabled: false };
  }
  let firebaseConfig;
  if (target === 'emulator') {
    if (!Object.values(emulators).every((host) => /^(localhost|127\.0\.0\.1):[0-9]{2,5}$/.test(host || '')
      && Number(host.split(':')[1]) <= 65535)) {
      throw new Error('Emulator builds require explicit loopback Auth, Firestore and Storage endpoints.');
    }
    const projectId = env.REACT_APP_FIREBASE_PROJECT_ID || 'demo-keval-blog';
    if (!/^demo-[a-z0-9-]+$/.test(projectId)) throw new Error('Emulators require a demo- project.');
    firebaseConfig = { apiKey: 'demo-api-key', projectId, authDomain: `${projectId}.firebaseapp.com`,
      storageBucket: `${projectId}.appspot.com`, appId: 'demo-keval-blog' };
  } else {
    if (Object.values(emulators).some(Boolean)) throw new Error('Real backends reject emulator endpoints.');
    if (target === 'production') {
      if (env.REACT_APP_FIREBASE_PROJECT_ID && env.REACT_APP_FIREBASE_PROJECT_ID !== production.projectId) {
        throw new Error('Production project must be keval-io.');
      }
      firebaseConfig = production;
    } else {
      firebaseConfig = Object.fromEntries([
        ['apiKey', 'API_KEY'], ['projectId', 'PROJECT_ID'], ['authDomain', 'AUTH_DOMAIN'],
        ['storageBucket', 'STORAGE_BUCKET'], ['appId', 'APP_ID'],
      ].map(([key, suffix]) => [key, env[`REACT_APP_FIREBASE_${suffix}`]]));
      if (Object.values(firebaseConfig).some((value) => !value)
        || !/^[a-z][a-z0-9-]+$/.test(firebaseConfig.projectId)
        || firebaseConfig.projectId.startsWith('demo-')
        || Object.values(firebaseConfig).some((value) => value.includes('keval-io') || Object.values(production).includes(value))) {
        throw new Error('Development requires a complete, separate Firebase backend; production fallback is forbidden.');
      }
    }
  }
  const ownerUid = target === 'emulator' ? 'blog-emulator-owner' : (env.REACT_APP_BLOG_OWNER_UID || '');
  const writesEnabled = target === 'emulator' || env.REACT_APP_BLOG_WRITES_ENABLED === 'true';
  const uploadsEnabled = target === 'emulator' || env.REACT_APP_BLOG_UPLOADS_ENABLED === 'true';
  if ((writesEnabled || uploadsEnabled) && !ownerUid) throw new Error('Blog writes require the verified owner UID.');
  if (uploadsEnabled && !writesEnabled) throw new Error('Uploads require enabled blog writes.');
  return { firebaseConfig, target, ownerUid, emulators, writesEnabled, uploadsEnabled };
}

module.exports = { resolveEnvironment };
